'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    scroller: {
        height: "100%",
    },
    flexContainer: {
        height: "100%",
        marginLeft: 2,
        marginRight: 2,
    },
    root: {
        fontSize: variables.SIZES.TEXT_MEDIUM,
        fontWeight: "bold",
    },
    indicator: {
        height: 2,
    },
};

var MuiTabs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiTabs = MuiTabs;
exports.light = light;
